import { __assign } from "tslib";
import { StyleSheet, Platform } from 'react-native';
import { textStyle } from '../v2/theme';
export default StyleSheet.create({
  cardContainer: {
    paddingHorizontal: 10,
    paddingVertical: Platform.OS === 'web' ? 8 : 10,
    flex: 1,
    width: '100%'
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: 12,
    flex: 1,
    flexBasis: '100%',
    flexShrink: 1,
    padding: 16,
    minHeight: 280,
    height: '100%'
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingLeft: 16
  },
  titleText: __assign(__assign({}, textStyle.homeCardTitle), {
    paddingRight: 16,
    paddingTop: Platform.OS === 'web' ? 12 : 16,
    maxWidth: Platform.OS !== 'web' && '85%',
    overflowWrap: 'anywhere'
  }),
  icon: {
    paddingTop: Platform.OS === 'web' ? 0 : 8,
    paddingRight: 0
  },
  body: {
    paddingHorizontal: 16,
    paddingTop: 24
  },
  bodyText: __assign(__assign({}, textStyle.homeCardBodyText), {
    lineHeight: 20
  }),
  footer: {
    flexDirection: 'row',
    justifyContent: 'center',
    justifySelf: 'flex-end',
    paddingTop: 24,
    paddingBottom: 8,
    paddingHorizontal: 8
  },
  button: {
    width: '85%',
    margin: 10,
    backgroundColor: '#fff',
    shadowColor: 'white',
    borderWidth: 1,
    borderColor: '#003087',
    alignItems: 'flex-start',
    borderRadius: 6
  },
  buttonText: __assign({}, textStyle.homeCardButtonText)
});